import DisableDevtool from 'disable-devtool';

const redirect = 'about:blank';

function clearSensitiveCache() {
  try {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('orderDetail');
    sessionStorage.removeItem('orderInfo');
    localStorage.removeItem('dlInfo');
  } catch (e) {
    /* ignore */
  }
}

function shouldEnableGuard() {
  if (process.env.NODE_ENV !== 'production') return false;
  return !/^(localhost|127\.0\.0\.1)$/i.test(location.hostname);
}

// if (shouldEnableGuard()) {
  DisableDevtool({
    url: redirect,
    timeOutUrl: redirect,
    interval: 200,
    disableMenu: true,
    clearLog: true,
    clearIntervalWhenDevOpenTrigger: false,
    detectors: 'all',
    ondevtoolopen() {
      clearSensitiveCache();
      if (location.href !== redirect) {
        location.replace(redirect);
      }
    },
  });
// }
